export default __webpack_public_path__ + "static/media/play-ico.0afd5655.svg";